import { useAppSelector } from "hooks";
import { useLinks } from "hooks/useLinks";
import { Navigation } from "interfaces";
import { debounce } from "lodash";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectCommonState, selectPopUpManagerState } from "redux/slices";

interface tutorialProps {
	pages: Navigation[];
	onGoToSlide: (index: number) => void;
}

export const useTutorialSlide = ({ pages, onGoToSlide }: tutorialProps) => {
	const links = useLinks();
	const { variant } = useSelector(selectPopUpManagerState);
	const { tutorialSlideNumber } = useAppSelector(selectCommonState);

	const handleResize = () => {
		pages.find((page: Navigation, index: number) => {
			if (page.path === links.loyalty.path && variant === "tutorial") {
				onGoToSlide(index);
			}
		});
	};

	useEffect(() => {
		if (variant === "tutorial-loyalty-shop") {
			onGoToSlide(0);
		}
	}, [variant]);

	useEffect(() => {
		if (tutorialSlideNumber === 7 && variant === "tutorial") {
			handleResize();
		}
	}, [tutorialSlideNumber]);

	const debounceHandleResize = debounce(handleResize, 100);

	useEffect(() => {
		window.addEventListener("resize", debounceHandleResize);
		window.addEventListener("transitionend", debounceHandleResize);

		return () => {
			window.removeEventListener("resize", debounceHandleResize);
			window.removeEventListener("transitionend", debounceHandleResize);
		};
	}, [variant, tutorialSlideNumber]);
};
